import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function IndyClientExport({ client }) {
  const [indyType, setIndyType] = useState("PARTICULIER");
  const [indySiret, setIndySiret] = useState("");

  const download = async () => {
    try {
      const r = await api.post("/indy/client-csv", {
        name: client.name, email: client.email, phone: client.phone,
        address: client.address, postal_code: client.postal_code, city: client.city,
        type: indyType, siret: indySiret,
      });
      const blob = new Blob([r.data.content], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = r.data.filename;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("CSV client Indy téléchargé — importez-le dans Indy (Clients → Importer)");
    } catch (e) { toast.error(e.response?.data?.detail || "Export Indy impossible"); }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-2" data-testid="indy-export-block">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500">Export Indy — fiche client</p>
      <div className="flex flex-wrap items-end gap-2">
        <div className="space-y-1">
          <label className="text-xs text-slate-500">Type</label>
          <select data-testid="indy-type" value={indyType} onChange={(e) => setIndyType(e.target.value)} className="h-9 rounded-md border border-input bg-white px-2 text-sm">
            <option value="PARTICULIER">Particulier</option>
            <option value="ENTREPRISE">Entreprise</option>
          </select>
        </div>
        {indyType === "ENTREPRISE" && (
          <div className="space-y-1">
            <label className="text-xs text-slate-500">N° SIRET (entreprise française) *</label>
            <Input data-testid="indy-siret" value={indySiret} onChange={(e) => setIndySiret(e.target.value)} placeholder="14 chiffres" className="h-9" />
          </div>
        )}
        <Button type="button" size="sm" variant="outline" data-testid="indy-csv-download" onClick={download}>
          <Download className="h-4 w-4 mr-1.5" /> Télécharger le CSV client Indy
        </Button>
      </div>
      <p className="text-xs text-slate-400">Format officiel Indy : colonnes dans l'ordre strict, séparateur virgule, pays ISO (FR). À importer dans Indy → Clients → Importer des clients.</p>
    </div>
  );
}
